import { __awaiter, __generator } from "tslib";
import queryString from 'query-string';
import { getAppByVersion } from '@wix/ambassador-devcenter-apps-v1-app-old/http';
export var Platform;
(function (Platform) {
    Platform["DASHBOARD"] = "dashboard";
    Platform["EDITOR"] = "editor";
    Platform["STANDALONE"] = "standalone";
})(Platform || (Platform = {}));
function isValidHttpUrl(string) {
    var url;
    try {
        url = new URL(string);
    }
    catch (_) {
        return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
}
function isBrowser() {
    return typeof window !== 'undefined';
}
var ClientSDK = /** @class */ (function () {
    function ClientSDK(options) {
        var _this = this;
        this.closeInstaller = function () {
            window.removeEventListener('message', _this.onFinishInstall);
            window.removeEventListener('message', _this.onFinishInstallWithIntent);
            _this.installationModal && _this.installationModal.close();
        };
        this.handleRequiredActionForEditor = function (requiredActionsMessage) {
            var requiredAction = requiredActionsMessage &&
                requiredActionsMessage.data &&
                requiredActionsMessage.data.requiredActions;
            var actionType = requiredAction && requiredAction.actionType;
            var appId = requiredActionsMessage &&
                requiredActionsMessage.data &&
                requiredActionsMessage.data.appId;
            var appVersion = requiredActionsMessage &&
                requiredActionsMessage.data &&
                requiredActionsMessage.data.appVersion;
            var isValid = isValidHttpUrl(requiredAction === null || requiredAction === void 0 ? void 0 : requiredAction.link);
            if (_this.platform === Platform.DASHBOARD) {
                if ((actionType === 'EDITOR' || actionType === 'CREATE_SITE') &&
                    isValid) {
                    _this.closeInstaller();
                    window.open(requiredAction.link);
                }
                else if (actionType === 'DASHBOARD' && isValid) {
                    window.location.href = requiredAction.link;
                    _this.closeInstaller();
                }
            }
            else if (_this.platform === Platform.EDITOR) {
                if (actionType === 'EDITOR') {
                    _this.editorSDK &&
                        _this.editorSDK.addApp({
                            appDefId: appId,
                            appVersion: appVersion,
                        });
                    _this.onEditorFinishAdd && _this.onEditorFinishAdd(appId);
                    _this.closeInstaller();
                }
                else if (actionType === 'DASHBOARD' && isValid) {
                    _this.closeInstaller();
                    window.open(requiredAction.link);
                }
            }
            else if (isValid) {
                // standalone
                window.location = requiredAction && requiredAction.link;
                _this.closeInstaller();
            }
        };
        this.handleRequiredActionForToken = function (requiredActionsMessage, actionType) {
            var requiredActions = requiredActionsMessage &&
                requiredActionsMessage.data &&
                requiredActionsMessage.data.requiredActions;
            var requiredAction = requiredActions &&
                requiredActions.find(function (action) { return action.actionType === actionType; });
            var appId = requiredActionsMessage &&
                requiredActionsMessage.data &&
                requiredActionsMessage.data.appId;
            var appVersion = requiredActionsMessage &&
                requiredActionsMessage.data &&
                requiredActionsMessage.data.appVersion;
            var isValid = isValidHttpUrl(requiredAction === null || requiredAction === void 0 ? void 0 : requiredAction.link);
            if (_this.platform === Platform.DASHBOARD) {
                if ((actionType === 'EDITOR' || actionType === 'CREATE_SITE') &&
                    isValid) {
                    _this.closeInstaller();
                    window.open(requiredAction.link);
                }
                else if (actionType === 'DASHBOARD' && isValid) {
                    window.location.href = requiredAction.link;
                    _this.closeInstaller();
                }
            }
            else if (_this.platform === Platform.EDITOR) {
                if (actionType === 'EDITOR') {
                    _this.editorSDK &&
                        _this.editorSDK.addApp({
                            appDefId: appId,
                            appVersion: appVersion,
                        });
                    _this.onEditorFinishAdd && _this.onEditorFinishAdd(appId);
                    _this.closeInstaller();
                }
                else if (actionType === 'DASHBOARD' && isValid) {
                    _this.closeInstaller();
                    window.open(requiredAction.link);
                }
            }
            else if (isValid) {
                // standalone
                window.location = requiredAction.link;
                _this.closeInstaller();
            }
        };
        this.handleRequiredAction = function (requiredAction, message) {
            var isValid = isValidHttpUrl(requiredAction === null || requiredAction === void 0 ? void 0 : requiredAction.link);
            if (_this.platform === Platform.DASHBOARD) {
                if (isValid &&
                    (requiredAction.actionType === 'EDITOR' ||
                        requiredAction.actionType === 'CREATE_SITE')) {
                    window.open(requiredAction.link);
                    _this.closeInstaller();
                }
                else if (requiredAction.actionType === 'DASHBOARD' && isValid) {
                    window.location.href = requiredAction.link;
                    _this.closeInstaller();
                }
                else if (requiredAction.actionType === 'MANAGE_APPS') {
                    if (_this.goToManageApps) {
                        _this.goToManageApps();
                    }
                    else if (isValidHttpUrl(requiredAction.link)) {
                        window.open(requiredAction.link);
                    }
                }
            }
            else if (_this.platform === Platform.EDITOR) {
                if (requiredAction.actionType === 'EDITOR') {
                    _this.editorSDK &&
                        _this.editorSDK.addApp({
                            appDefId: message && message.data.appId,
                            appVersion: message && message.data.appVersion,
                        });
                    _this.onEditorFinishAdd &&
                        _this.onEditorFinishAdd(message && message.data.appId);
                    _this.closeInstaller();
                }
                else if (requiredAction.actionType === 'DASHBOARD' && isValid) {
                    _this.closeInstaller();
                    window.open(requiredAction.link);
                    // this.closeInstaller();
                }
                else if (requiredAction.actionType === 'MANAGE_APPS') {
                    _this.goToManageApps();
                }
            }
            else if (isValid) {
                // standalone
                window.location = requiredAction && requiredAction.link;
                _this.closeInstaller();
            }
        };
        this.onFinishInstall = function (message) {
            var _a, _b, _c, _d, _e, _f;
            if (message.data.installStatus === 'waitForTokenReceived') {
                console.log('waitForTokenReceived1', message);
                _this.tokenRequiredActionsMessage = message;
                return;
            }
            if (message.data.installStatus === 'getPlatform') {
                console.log('on getPlatform in handleRequiredAction');
                _this.installationModal.postMessage({
                    platformForInstaller: (_b = (_a = _this.tokenRequiredActionsMessage) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.platform,
                    isInUpdateFlow: (_d = (_c = _this.tokenRequiredActionsMessage) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.isInUpdateFlow,
                    isBusinessFirst: (_f = (_e = _this.tokenRequiredActionsMessage) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.isBusinessFirst,
                    src: 'installerSDK',
                }, '*');
                return;
            }
            if (message.data.installStatus === 'tokenReceived') {
                // this code will be deleted, sorry
                if (_this.requiredActionsMessage === null) {
                    _this.handleRequiredActionForToken(_this.tokenRequiredActionsMessage, _this.tokenRequiredActionsMessage.data.actionType);
                }
                else {
                    _this.handleRequiredActionForEditor(_this.requiredActionsMessage);
                }
            }
            if (message.data.installStatus === 'tokenReceivedV2') {
                _this.handleRequiredActionForToken(_this.tokenRequiredActionsMessage, message.data.actionType);
            }
            if (message.data.installStatus === 'onProvisionSuccess' ||
                message.data.installStatus === 'silentEditor') {
                _this.onInstallationSuccess &&
                    _this.onInstallationSuccess({
                        instance_id: message.data && message.data.instanceId,
                        msid: message.data && message.data.msid,
                    });
            }
            if (message.data.installStatus === 'silentEditor') {
                _this.editorSDK &&
                    _this.editorSDK.addApp({
                        appDefId: message && message.data.appId,
                        appVersion: message && message.data.appVersion,
                    });
                _this.onEditorFinishAdd &&
                    _this.onEditorFinishAdd(message && message.data.appId);
                _this.closeInstaller();
            }
            if (message.data.requiredActions) {
                var requiredAction = message.data.requiredActions;
                _this.handleRequiredAction(requiredAction, message);
            }
            else if (message.data.installStatus === 'close') {
                _this.closeInstaller();
            }
            else if ((message.data && message.data.installStatus === 'cancel') ||
                (message.data && message.data.type === 'FINISH_INSTALLATION_EMBEDDED')) {
                _this.closeInstaller();
            }
            else if (message.data && message.data.installStatus === 'fail') {
                _this.onInstallationFail({
                    reason: message.data.reason,
                });
            }
        };
        this.getMiddleCoordinate = function (popupWindowSize, screenSize) {
            return screenSize / 2 - popupWindowSize / 2;
        };
        this.installApp = function (_a) {
            var appDefId = _a.appDefId, version = _a.version, openMethod = _a.openMethod, shareId = _a.shareId, onInstallationSuccess = _a.onInstallationSuccess, onInstallationFail = _a.onInstallationFail, referredByAppId = _a.referredByAppId, goToManageApps = _a.goToManageApps;
            _this.openMethod = openMethod;
            _this.goToManageApps = goToManageApps;
            _this.onInstallationSuccess = onInstallationSuccess;
            _this.onInstallationFail = onInstallationFail;
            _this.requiredActionsMessage = null;
            _this.tokenRequiredActionsMessage = null;
            if (openMethod === 'NEW_TAB' || _this.platform === 'standalone') {
                window.addEventListener('message', _this.onFinishInstall);
                var search = queryString.stringify({
                    version: version,
                    metaSiteId: _this.metaSiteId,
                    platform: _this.platform,
                    shareId: shareId,
                    referredByAppId: referredByAppId,
                });
                var installerUrl = isBrowser()
                    ? "".concat(window.location.origin, "/installer/install?appId=")
                    : 'https://www.wix.com/installer/install?appId=';
                _this.frameSrc = "".concat(installerUrl).concat(appDefId, "&").concat(search);
                _this.installationModal = window.open(_this.frameSrc);
            }
            else {
                var width = 600;
                var height = 650;
                var popupWindowTop = _this.getMiddleCoordinate(height, window.screen.height);
                var popupWindowLeft = _this.getMiddleCoordinate(width, window.screen.width);
                window.addEventListener('message', _this.onFinishInstall);
                var search = queryString.stringify({
                    version: version,
                    metaSiteId: _this.metaSiteId,
                    platform: _this.platform,
                    shareId: shareId,
                    modal: true,
                    referredByAppId: referredByAppId,
                });
                var installerUrl = isBrowser()
                    ? "".concat(window.location.origin, "/installer/install?appId=")
                    : 'https://www.wix.com/installer/install?appId=';
                _this.frameSrc = "".concat(installerUrl).concat(appDefId, "&").concat(search);
                _this.installationModal = window.open(_this.frameSrc, '_blank', "height=".concat(height, ",width=").concat(width, ",top=").concat(popupWindowTop, ",left=").concat(popupWindowLeft));
            }
        };
        this.finishEditorInstallation = function (appDefId, appVersion, options) {
            var params = appVersion !== ''
                ? { appDefId: appDefId, appVersion: appVersion, options: options }
                : { appDefId: appDefId, options: options };
            _this.editorSDK && _this.editorSDK.addApp(params);
            _this.onEditorFinishAdd && _this.onEditorFinishAdd(appDefId);
        };
        this.setMetaSiteId = function (msid) {
            _this.metaSiteId = msid;
        };
        this.onFinishInstallWithIntent = function (message) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var installStatus = (_a = message === null || message === void 0 ? void 0 : message.data) === null || _a === void 0 ? void 0 : _a.installStatus;
            if (installStatus === 'onProvisionSuccess') {
                _this.onInstallationSuccess &&
                    _this.onInstallationSuccess({
                        applicationId: _this.appId,
                        instance_id: message.data && message.data.instanceId,
                        msid: message.data && message.data.msid,
                    });
            }
            if (installStatus === 'close') {
                _this.onInstallationWindowClosed && _this.onInstallationWindowClosed({});
                _this.closeInstaller();
                return;
            }
            if (installStatus === 'pclose') {
                _this.onInstallationSuccess && _this.onInstallationSuccess({});
                _this.closeInstaller();
                return;
            }
            if (installStatus === 'cancel') {
                _this.onInstallationCancel && _this.onInstallationCancel({});
                _this.closeInstaller();
                return;
            }
            if (installStatus === 'tokenReceived') {
                _this.closeInstaller();
                _this.onInstallationSuccess({
                    applicationId: _this.appId,
                    instance_id: (_b = message === null || message === void 0 ? void 0 : message.data) === null || _b === void 0 ? void 0 : _b.instanceId,
                    msid: (_c = message === null || message === void 0 ? void 0 : message.data) === null || _c === void 0 ? void 0 : _c.msid,
                });
                return;
            }
            if (installStatus === 'waitForTokenReceived') {
                console.log('waitForTokenReceived2', message);
                _this.tokenRequiredActionsMessage = message;
                return;
            }
            if (message.data.installStatus === 'getPlatform') {
                console.log('on getPlatform in finishEditorInstallation');
                _this.installationModal.postMessage({
                    platformForInstaller: (_d = _this === null || _this === void 0 ? void 0 : _this.tokenRequiredActionsMessage) === null || _d === void 0 ? void 0 : _d.data.platform,
                    isInUpdateFlow: (_f = (_e = _this === null || _this === void 0 ? void 0 : _this.tokenRequiredActionsMessage) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.isInUpdateFlow,
                    installIntent: (_h = (_g = _this === null || _this === void 0 ? void 0 : _this.tokenRequiredActionsMessage) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.installIntent,
                    src: 'installerSDK',
                }, '*');
                return;
            }
            if (message.data.installStatus === 'silentEditor') {
                _this.closeInstaller();
                _this.onInstallationSuccess && _this.onInstallationSuccess({});
            }
        };
        this.installAppWithIntent = function (_a) {
            var appDefId = _a.appDefId, version = _a.version, openMethod = _a.openMethod, onInstallationSuccess = _a.onInstallationSuccess, onInstallationFail = _a.onInstallationFail, intent = _a.intent, onInstallationCancel = _a.onInstallationCancel, onInstallationWindowClosed = _a.onInstallationWindowClosed;
            return __awaiter(_this, void 0, void 0, function () {
                var search, appByVersionResponse, wixApp, installSeamlessUrl, installerUrl, width, height, popupWindowTop, popupWindowLeft;
                var _this = this;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.openMethod = openMethod;
                            this.onInstallationSuccess = onInstallationSuccess;
                            this.onInstallationFail = onInstallationFail;
                            this.onInstallationWindowClosed = onInstallationWindowClosed;
                            this.onInstallationCancel = onInstallationCancel;
                            this.requiredActionsMessage = null;
                            this.tokenRequiredActionsMessage = null;
                            this.appId = appDefId;
                            search = queryString.stringify({
                                version: version,
                                metaSiteId: this.metaSiteId,
                                platform: this.platform,
                                intent: intent,
                            });
                            return [4 /*yield*/, this.httpClient.request(getAppByVersion({ appId: appDefId, version: version !== null && version !== void 0 ? version : 'latest' }))];
                        case 1:
                            appByVersionResponse = _c.sent();
                            wixApp = (_b = appByVersionResponse.data.isWixApp) !== null && _b !== void 0 ? _b : false;
                            if (!(intent === 'plugins' && wixApp)) return [3 /*break*/, 3];
                            installSeamlessUrl = isBrowser()
                                ? "".concat(window.location.origin, "/installer/install-seamless?appId=")
                                : 'https://www.wix.com/installer/install-seamless?appId=';
                            return [4 /*yield*/, this.httpClient
                                    .get("".concat(installSeamlessUrl).concat(appDefId, "&").concat(search))
                                    .then(function () {
                                    _this.onInstallationSuccess && _this.onInstallationSuccess({});
                                    _this.closeInstaller();
                                    return;
                                })
                                    .catch(function (error) { return console.log(error); })];
                        case 2:
                            _c.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            window.addEventListener('message', this.onFinishInstallWithIntent);
                            installerUrl = isBrowser()
                                ? "".concat(window.location.origin, "/installer/install?appId=")
                                : 'https://www.wix.com/installer/install?appId=';
                            this.frameSrc = "".concat(installerUrl).concat(appDefId, "&").concat(search);
                            if (openMethod === 'NEW_TAB') {
                                this.installationModal = window.open(this.frameSrc);
                            }
                            else {
                                width = 600;
                                height = 650;
                                popupWindowTop = this.getMiddleCoordinate(height, window.screen.height);
                                popupWindowLeft = this.getMiddleCoordinate(width, window.screen.width);
                                this.installationModal = window.open(this.frameSrc, '_blank', "height=".concat(height, ",width=").concat(width, ",top=").concat(popupWindowTop, ",left=").concat(popupWindowLeft));
                            }
                            _c.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        this.installPartnerApp = function (_a) {
            var appDefId = _a.appDefId, version = _a.version, openMethod = _a.openMethod, onInstallationSuccess = _a.onInstallationSuccess, onInstallationFail = _a.onInstallationFail, _b = _a.intent, intent = _b === void 0 ? 'partners' : _b, onInstallationCancel = _a.onInstallationCancel, onInstallationWindowClosed = _a.onInstallationWindowClosed;
            return __awaiter(_this, void 0, void 0, function () {
                var search, appByVersionResponse, installSeamlessUrl, installerUrl;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            search = queryString.stringify({
                                version: version,
                                metaSiteId: this.metaSiteId,
                                platform: this.platform,
                                intent: intent,
                            });
                            return [4 /*yield*/, this.httpClient.request(getAppByVersion({ appId: appDefId, version: version !== null && version !== void 0 ? version : 'latest' }))];
                        case 1:
                            appByVersionResponse = _c.sent();
                            if (!appByVersionResponse.data.authData) {
                                installSeamlessUrl = isBrowser()
                                    ? "".concat(window.location.origin, "/installer/install-seamless?appId=")
                                    : 'https://www.wix.com/installer/install-seamless?appId=';
                                window.open("".concat(installSeamlessUrl).concat(appDefId, "&").concat(search));
                            }
                            else {
                                this.openMethod = openMethod;
                                this.onInstallationSuccess = onInstallationSuccess;
                                this.onInstallationFail = onInstallationFail;
                                this.onInstallationWindowClosed = onInstallationWindowClosed;
                                this.onInstallationCancel = onInstallationCancel;
                                this.requiredActionsMessage = null;
                                this.tokenRequiredActionsMessage = null;
                                this.appId = appDefId;
                                window.addEventListener('message', this.onFinishInstallWithIntent);
                                installerUrl = isBrowser()
                                    ? "".concat(window.location.origin, "/installer/install?appId=")
                                    : 'https://www.wix.com/installer/install?appId=';
                                this.frameSrc = "".concat(installerUrl).concat(appDefId, "&").concat(search);
                                this.installationModal = window.open(this.frameSrc);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.platform = options.platform;
        this.metaSiteId = options.metaSiteId;
        this.editorSDK = options.editorSDK;
        this.requiredActionsMessage = null;
        this.tokenRequiredActionsMessage = null;
        this.frameSrc = '';
        this.appId = '';
        this.httpClient = options.httpClient;
        this.onFinishInstall = this.onFinishInstall.bind(this);
        this.onFinishInstallWithIntent = this.onFinishInstallWithIntent.bind(this);
        this.closeInstaller = this.closeInstaller.bind(this);
        this.handleRequiredAction = this.handleRequiredAction.bind(this);
        this.handleRequiredActionForEditor = this.handleRequiredActionForEditor.bind(this);
        this.onEditorFinishAdd =
            typeof options.onEditorFinishAdd === 'function'
                ? options.onEditorFinishAdd.bind(this)
                : undefined;
        this.setMetaSiteId = this.setMetaSiteId.bind(this);
        this.getMiddleCoordinate = this.getMiddleCoordinate.bind(this);
        this.goToManageApps = this.goToManageApps && this.goToManageApps.bind(this);
    }
    return ClientSDK;
}());
export { ClientSDK };
//# sourceMappingURL=installer-client-sdk.js.map